// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';

import MobileSportsRouteView from './MobileSportsRouteView';
import selectMobileSportsRouteViewProps from './MobileSportsRouteView.selector';

const MobileSportsRouteViewContainer = () => {
  const selectedProps = useSelector(selectMobileSportsRouteViewProps);

  return <MobileSportsRouteView {...selectedProps} />;
};

export default MobileSportsRouteViewContainer;
